import React from 'react';
import { CompDisplayResponse } from '../../services/displayFramework';

export type DisplayFrameworkContextValue = {
  getComponentConfiguration: (
    comcode: string
  ) => CompDisplayResponse | undefined;
  getComponentLabel: (comcode: string) => string;
  refresh: () => void;
  isError: boolean;
  isFetching: boolean;
  pagcode?: string;
  getAttributeListByComcode: (comcode: string) => any;
  getAttributeList: () => any[] | undefined;
};

const warnAboutMissingContext = (valueToReturn: any) => {
  console.warn(
    'Display Framework context was used, but it is missing. Did you forget to wrap component in Provider?'
  );
  return valueToReturn;
};

const defaultContext: DisplayFrameworkContextValue = {
  getComponentConfiguration: warnAboutMissingContext(undefined),
  getComponentLabel: warnAboutMissingContext(''),
  refresh: warnAboutMissingContext(''),
  isError: false,
  isFetching: false,
  pagcode: '',
  getAttributeListByComcode: warnAboutMissingContext(undefined),
  getAttributeList: warnAboutMissingContext(undefined),
};

export const DisplayFrameworkContext =
  React.createContext<DisplayFrameworkContextValue>(defaultContext);
